"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Formatter = void 0;
const date_fns_1 = require("date-fns");
class Formatter {
    formatAddresses(addresses) {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        const formattedAddresses = [];
        for (const address of addresses) {
            if (address.identifiers.length) {
                const primaryIdentifier = this.primaryIdentifier(address.identifiers);
                if (primaryIdentifier) {
                    formattedAddresses.push({
                        address: (_a = address.address) !== null && _a !== void 0 ? _a : '',
                        carrier: (_b = primaryIdentifier.name) !== null && _b !== void 0 ? _b : '',
                        carrier_id: (_c = primaryIdentifier.value) !== null && _c !== void 0 ? _c : '',
                        gnaf: this.gnaf(address.identifiers),
                        id: (_d = address.id) !== null && _d !== void 0 ? _d : '',
                        identifiers: address.identifiers
                    });
                }
            }
            if (address.geographicSubAddress.length) {
                for (const subAddress of address.geographicSubAddress) {
                    if (subAddress.identifiers.length) {
                        const primaryIdentifier = this.primaryIdentifier(subAddress.identifiers);
                        if (primaryIdentifier) {
                            formattedAddresses.push({
                                address: (_e = subAddress.address) !== null && _e !== void 0 ? _e : '',
                                carrier: (_f = primaryIdentifier.name) !== null && _f !== void 0 ? _f : '',
                                carrier_id: (_g = primaryIdentifier.value) !== null && _g !== void 0 ? _g : '',
                                gnaf: this.gnaf(subAddress.identifiers),
                                id: (_h = subAddress.id) !== null && _h !== void 0 ? _h : '',
                                identifiers: subAddress.identifiers
                            });
                        }
                    }
                }
            }
        }
        return formattedAddresses;
    }
    formatServiceQualificationItems(serviceQualificationQuery) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u;
        const formattedServiceQualifications = [];
        for (const serviceQualificationItem of serviceQualificationQuery.serviceQualificationItem) {
            const rtcDate = serviceQualificationItem.expectedServiceAvailabilityDate;
            let finalRtcDate = '';
            if (rtcDate !== undefined) {
                finalRtcDate = date_fns_1.format(new Date(rtcDate), 'yyyy-MM-dd');
            }
            const formattedServiceQualification = {
                sq_id: (_a = serviceQualificationQuery.id) !== null && _a !== void 0 ? _a : '',
                address: '',
                building: '',
                development_name: '',
                gnaf: '',
                level_number: '',
                level_type: '',
                lot_number: '',
                postcode: '',
                state: '',
                street_name: '',
                street_number: '',
                street_suffix: '',
                street_type: '',
                suburb: '',
                unit_number: '',
                unit_type: '',
                id: (_b = serviceQualificationItem.id) !== null && _b !== void 0 ? _b : '',
                carrier: this.characteristic(serviceQualificationItem.service, 'Carrier'),
                carrier_id: this.characteristic(serviceQualificationItem.service, 'CarrierId'),
                max_download: +this.characteristic(serviceQualificationItem.service, 'MaxDownloadSpeed'),
                min_download: +this.characteristic(serviceQualificationItem.service, 'MinDownloadSpeed'),
                max_upload: +this.characteristic(serviceQualificationItem.service, 'MaxUploadSpeed'),
                min_upload: +this.characteristic(serviceQualificationItem.service, 'MinUploadSpeed'),
                ndc: this.characteristic(serviceQualificationItem.service, 'NDCApplies') === 'true' ? 300 : 0,
                technology: this.characteristic(serviceQualificationItem.service, 'Technology'),
                topology: this.characteristic(serviceQualificationItem.service, 'Technology'),
                rtc_date: finalRtcDate,
                service_class: this.characteristic(serviceQualificationItem.service, 'ServiceClass'),
                alternate_technology: (_c = this.characteristic(serviceQualificationItem.service, 'AlternativeTechnology')) !== null && _c !== void 0 ? _c : '',
                alternate_technology_status: (_d = this.characteristic(serviceQualificationItem.service, 'AlternativeTechnologyStatus')) !== null && _d !== void 0 ? _d : '',
                alternate_technology_date: this.characteristic(serviceQualificationItem.service, 'AlternativeTechnologyForecastDate') ? date_fns_1.format(new Date(this.characteristic(serviceQualificationItem.service, 'AlternativeTechnologyForecastDate')), 'yyyy-MM-dd') : '',
                ntd_location: this.characteristic(serviceQualificationItem.service, 'NtdLocation'),
                velocity_status: this.characteristic(serviceQualificationItem.service, 'VelocityStatus'),
                is_competitive: this.characteristic(serviceQualificationItem.service, 'IsCompetitive') === 'true',
                ncc: this.characteristic(serviceQualificationItem.service, 'NCCApplies') === 'true' ? +this.characteristic(serviceQualificationItem.service, 'NCCAmount') : 0,
                expected_activation_date: serviceQualificationItem.expectedActivationDate ? date_fns_1.format(new Date(serviceQualificationItem.expectedActivationDate), 'yyyy-MM-dd') : '',
                is_btr: this.characteristic(serviceQualificationItem.service, 'IsBtr') === 'true',
                is_velocity: this.characteristic(serviceQualificationItem.service, 'IsVelocity') === 'true'
            };
            const address = serviceQualificationItem.service.place.find(place => place['@type'] === 'UnitiGeographicAddress');
            if (address) {
                // We know the type from the query above.
                const geographicAddress = address;
                formattedServiceQualification.address = (_e = geographicAddress.address) !== null && _e !== void 0 ? _e : '';
                formattedServiceQualification.postcode = (_f = geographicAddress.postcode) !== null && _f !== void 0 ? _f : '';
                formattedServiceQualification.state = (_g = geographicAddress.stateOrProvince) !== null && _g !== void 0 ? _g : '';
                formattedServiceQualification.street_name = (_h = geographicAddress.streetName) !== null && _h !== void 0 ? _h : '';
                formattedServiceQualification.street_number = (_j = geographicAddress.streetNr) !== null && _j !== void 0 ? _j : '';
                formattedServiceQualification.street_suffix = (_k = geographicAddress.streetSuffix) !== null && _k !== void 0 ? _k : '';
                formattedServiceQualification.street_type = (_l = geographicAddress.streetType) !== null && _l !== void 0 ? _l : '';
                formattedServiceQualification.suburb = (_m = geographicAddress.city) !== null && _m !== void 0 ? _m : '';
                formattedServiceQualification.development_name = (_o = geographicAddress.locality) !== null && _o !== void 0 ? _o : '';
                if (geographicAddress.geographicSubAddress.length) {
                    const geographicSubAddress = geographicAddress.geographicSubAddress[0];
                    formattedServiceQualification.address = (_p = geographicSubAddress.address) !== null && _p !== void 0 ? _p : '';
                    formattedServiceQualification.building = (_q = geographicSubAddress.buildingName) !== null && _q !== void 0 ? _q : '';
                    formattedServiceQualification.level_number = (_r = geographicSubAddress.levelNumber) !== null && _r !== void 0 ? _r : '';
                    formattedServiceQualification.level_type = (_s = geographicSubAddress.levelType) !== null && _s !== void 0 ? _s : '';
                    formattedServiceQualification.lot_number = '';
                    formattedServiceQualification.unit_number = (_t = geographicSubAddress.subUnitNumber) !== null && _t !== void 0 ? _t : '';
                    formattedServiceQualification.unit_type = (_u = geographicSubAddress.subUnitType) !== null && _u !== void 0 ? _u : '';
                }
            }
            formattedServiceQualifications.push(formattedServiceQualification);
        }
        return formattedServiceQualifications;
    }
    primaryIdentifier(identifiers) {
        // Get OC identifier.
        const ocId = identifiers.find(id => id.type === 'carrier' && id.name === 'OC');
        if (ocId)
            return ocId;
        // Get NB identifier.
        const nbId = identifiers.find(id => id.type === 'carrier' && id.name === 'NB');
        if (nbId)
            return nbId;
        // Get any identifier.
        const anyId = identifiers.find(id => id.type === 'carrier');
        if (anyId)
            return anyId;
        return null;
    }
    gnaf(identifiers) {
        const gnaf = identifiers.find(id => id.type === 'gnaf');
        return gnaf && gnaf.value ? gnaf.value : '';
    }
    characteristic(service, name) {
        const characteristic = service.serviceCharacteristic.find(characteristic => characteristic.name === name);
        return characteristic && characteristic.value ? characteristic.value.toString() : '';
    }
}
exports.Formatter = Formatter;
//# sourceMappingURL=formatter.js.map